import $ from 'jquery'
import {pushDestinationMapLinks} from "./helpers/gtm";

const currencySelected = $('.currency-selected .current-currency')
const currencyDrop = $('.currency-selected .drop')
const langSelected = $('.languages .current-state')
const langDrop = $('.languages .drop')
// const touchEvent = 'ontouchend' in window ? 'touchend' : 'click'


currencySelected.on('click keypress', function (e) {
  if (
    e.type === "keydown" &&
    e.key !== "Enter" &&
    e.key !== " "
  ) {
    return;
  }
  $(this).toggleClass('show active')
})

langSelected.on('click keypress', function (e) {
  if (
    e.type === "keydown" &&
    e.key !== "Enter" &&
    e.key !== " "
  ) {
    return;
  }
  $(this).toggleClass('show active')
})

function selectButtons() {
  if ($(window).width() >= 1280) {
    $(document).on('click', (e) => {
      if (!$(e.target).closest(currencySelected).length && !$(e.target).closest(currencyDrop).length) {
        currencySelected.removeClass('active')
      }
      e.stopPropagation()
    })
    $(document).on('click', (e) => {
      if (!$(e.target).closest(langSelected).length && !$(e.target).closest(langDrop).length) {
        langSelected.removeClass('active')
      }
      e.stopPropagation()
    })
  }
}

selectButtons();

$(window).on('resize', selectButtons);

$('.footer-text-block__title').on('click', (e) => {
  $(e.target).toggleClass('show')
})

const defaultSize = 11
const currentSize = parseInt($('.bottom-line__copyright').css('font-size'))
const size = (currentSize * 100)/defaultSize

setTimeout(() => {
  $('.slide-panel').css('text-size-adjust', size + '%')
}, 750)
setTimeout(() => {
  $('.newsletter-widget .newsletter').css('text-size-adjust', size + '%')
}, 750)
setTimeout(() => {
  $('.quotes-widget-new__member').css('text-size-adjust', size + '%')
}, 750)
